<template>
  <common-dialog ref="dialog" width="70%" title="打印快递单" :confirm-on-close-change="false" @closed="onClosed">
    <template slot="form">
      <el-row>
        <el-col :span="12">
          <el-form-item label="选择快递模板" label-width="100px">
            <el-select v-model="data.temp">
              <el-option v-for="(i, k) in 模板列表" :key="k" :label="i.name + '，剩余单数' + i.number" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="选择打印机" label-width="100px">
            <el-select v-model="data.printer" placeholder="请选择" clearable>
              <el-option v-for="(i,k) in printerList" :key="k" :label="i.name" :value="i.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="默认发货地址" label-width="100px">
            <el-select v-model="data.address" placeholder="请选择" clearable>
              <el-option v-for="(i,k) in senderAddress" :key="k" :label="i.name" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="申请打印数">
            <span style="color: #D9001B;">{{ data.printCount }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="是否拆单">
            <el-checkbox v-model="data.separate" @change="onSeparateChange"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label-width="0">
            <div style="display: flex;">
              <div style="margin-right: 10px;">每笔订单获取</div>
              <el-input-number v-model="data.separateNumber" :min="2" :precision="0"
                :disabled="!data.separate"></el-input-number>
              <div style="margin-left: 10px;">个电子面单号</div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="data.rows" border class="merge-table" max-height="500">
            <el-table-column prop="address" label="订单来源" width="100">
              <div slot-scope="{row}" class="merge-item">
                <span>关联订单</span>
              </div>
            </el-table-column>
            <el-table-column prop="date" label="收货地址" min-width="350">
              <template slot-scope="{row}">
                <div class="merge-item" v-if="row.Id!=2">周**，17****199，江苏省苏州市吴中区江苏省苏*******建工恒泰项目部</div>
                <div class="merge-item" v-else>
                  <div class="badge badge-merge">合单4</div>
                  <span>陈**, 172*****406，江苏省/南通市/如东县/双逸创业园区******</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="订单号" width="200">
              <template slot-scope="{row}">
                <template v-if="row.Id==2">
                  <div class="merge-item">240318-529897952651816</div>
                  <div class="merge-item">240318-529897952651000</div>
                  <div class="merge-item">240318-529897952651111</div>
                </template>
                <template v-else>
                  <div class="merge-item">240316-535486831503318</div>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="Field8" label="运单号" width="200">
              <div slot-scope="{row}" class="merge-item">
                <template v-if="row.Field8 && row.Field8.length > 0">
                  <div v-for="(i1, k1) in row.Field8" :key="k1">
                    <div>{{ i1.Field8_1 }}：</div>
                    <div v-for="(i2, k2) in i1.Field8_2" :key="k2">{{ i2.Field8_2_1 }}</div>
                  </div>
                </template>
                <span v-else>无</span>
              </div>
            </el-table-column>
            <el-table-column label="操作" align="center" width="90" v-if="data.isPrint">
              <template slot-scope="{row}">
                <el-button type="text" @click="onPrintAfresh(row)">重新打印</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </template>
    <template slot="footer">
      <el-button v-if="!data.isPrint" type="primary" @click="onPrint">获取新单号并打印</el-button>
      <template v-else>
        <el-button type="primary" @click="onBatchPrintAfresh">批量重新打印</el-button>
        <el-button type="warning" @click="onAddNewNumberPrint">添加新单号打印</el-button>
      </template>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      orderApi: require("@/api/pdd/order").default,
      malladdressesApi: require('@/api/pdd/malladdresses').default,
      socket: null,
      data: {
        id: 0,
        isPrint: false,
        state: 0, //0：未打印，1：已打印，2：已锁定
        temp: null, //快递模板
        printer: "", //打印机
        separate: false, //拆单
        separateNumber: 2,
        surplusCount: 0, //剩余单数
        printCount: 0, //申请打印数
        address: "", //默认发货地址
        rows: [],
      },
      模板列表: [],
      printerList: [],
      senderAddress: [],
    };
  },
  mounted() { },
  methods: {
    setData(data) {
      console.log("setData", data);
      this.getTemp();
      this.getSenderAddress();
      this.onInitWs();
      this.data.printCount = data.rows.length;
      this.data.isPrint = data.isPrint;
      this.data.rows = data.rows;
    },
    setDataById(id) {
      this.getTemp();
      this.getSenderAddress();
      this.onInitWs();
      this.orderApi.getManual({ id }).then(res => {
        if (res.data.length > 0) {
          this.data.printCount = res.data.length;
          this.data.isPrint = false;
          this.data.rows = res.data;
        }
      })
    },
    getTemp() {
      this.模板列表.push({
        id: 1,
        name: "圆通快递",
        number: 3
      })
      this.模板列表.push({
        id: 2,
        name: "中通快递",
        number: 4
      })
      this.模板列表.push({
        id: 3,
        name: "韵达快递",
        number: 6
      })
    },
    getSenderAddress() {
      return new Promise((resolve, reject) => {
        this.malladdressesApi.getSender().then(res => {
          if (!res.errorCode) {
            this.senderAddress = res.data.map(x => {
              var addr = x.senderAddress;
              return { id: x.id, name: addr.country + addr.province + addr.city + addr.district + addr.detailAddress, data: x }
            });
          }
          resolve(res);
        }).catch(err => {
          reject(err)
        })
      })
    },
    //初始化websocket (要打开pdd打印组件，websocket才能连接上)
    onInitWs() {
      this.socket = new WebSocket("ws://127.0.0.1:5000");
      // 添加WebSocket事件监听器
      this.socket.addEventListener("open", this.onSocketOpen);
      this.socket.addEventListener("message", this.onSocketMessage);
      this.socket.addEventListener("close", this.onSocketClose);
      this.socket.addEventListener("error", this.onSocketError);
      // console.log("初始化", this.socket);
    },
    onSocketOpen() {
      console.log("WebSocket连接已打开");
      //获取本地打印机列表
      let data = {
        cmd: "getPrinters",
        requestID: "123458976",
        version: "1.0",
      };
      this.socket.send(JSON.stringify(data));
    },
    onSocketMessage(event) {
      console.log("收到WebSocket消息:", event.data);
      const result = JSON.parse(event.data);
      // console.log(result.cmd);
      if (result.cmd == "getPrinters") {
        this.printerList = result.printers;
      }
      if (result.cmd == "print") {
        console.log("打印信息");
      }
      // if (result.cmd == "PrintResultNotify") {
      //   console.log("打印结果通知");
      //   this.socket.close();
      // }
    },
    onSocketClose() {
      console.log("WebSocket连接已关闭");
    },
    onSocketError(event) {
      console.error("WebSocket连接错误:", event);
    },
    onSeparateChange() {
      this.data.separateNumber = 2;
    },
    onPrint() {
      console.log("打印");
    },
    onPrintAfresh(row) {
      if (!(row.Field8 && row.Field8.length > 0)) {
        this.$message.error("当前无运单号，请重新取号打印");
        return;
      }
      console.log("重新打印", row);
    },
    onBatchPrintAfresh() {
      console.log("批量重新打印");
    },
    onAddNewNumberPrint() {
      console.log("添加新单号打印");
    },
    onClosed() {
      if (this.socket) this.socket.close();
    }
  },
};
</script>